export const FORCE_EXP_KEY = 'force-exp-'
export const TEST_AUDIENCE = 'test-audience'
export const VARIATION = 'variation'

export const WT_CHECKOUT_CW = 'wt-checkout-cw'
export const VIEWPAGE_PLAGIARISM_EXPORT = 'viewpage-plagiarism-export'
export const UPLOAD_WIDGET_DEMO_FEATURE = 'upload-widget-demo'
export const IMPROVED_BOOK_JOURNAL_SEARCH = 'improved-search'
export const OWL_EXPERIMENT_KEY = 'owl-citation-widget-gam-z'
export const CW_PRICE_TEST = 'cw-price-test'
export const CROSSREF_RESULT_COUNT = 'crossref-result-count'
export const AUTOCITE_V0_RIO_EVENTS = 'autocite-v0-rio-events'
export const UPDATE_AUTOCITE_API = 'update-autocite-api'
export const UPDATE_MESSAGING_FEATURE_BM = 'update-messaging-bm'
export const UPDATE_MESSAGING_FEATURE_EB = 'update-messaging-eb'
export const UPDATE_MESSAGING_FEATURE_CTFM = 'update-messaging-ctfm'
export const UPDATE_MESSAGING_FEATURE_CM = 'update-messaging-cm'
export const ENABLE_PARAPHRASER = 'enable-paraphraser'
export const UPDATE_AUTH_MODAL_EB = 'eb-update-auth-modal'
export const EB_AD_UNLOCK_MODAL = 'eb-ad-unlock-modal'
export const GUEST_CITATION_VALIDITY_CM = 'guest-citation-validity-cm'
export const GUEST_CITATION_VALIDITY_EB = 'guest-citation-validity-eb'
export const AD_UNLOCK_MODAL_EB = 'ad_unlock_modal_eb'
export const AD_UNLOCK_MODAL_CM = 'ad_unlock_modal_cm'
export const WRITING_ASSISTANT_FEATURES = 'writing-assistant-features'

// low ad test
export const LOW_AD_EB = 'low-ad-eb'
export const LOW_AD_CM = 'low-ad-cm'
export const LOW_AD_CONTROL_CELL = 'low-ads-m-control'
export const LOW_AD_VARIATION1 = 'low-ads-m-test'
export const LOW_AD_VARIATION2 = 'low-ads-n-test'
export const LOW_AD_VARIATION3 = 'low-ads-o-test'
export const LOW_AD_DEFAULT_CM = 'low-ad-cm-control'
export const LOW_AD_DEFAULT_EB = 'low-ad-eb-control'
export const LOW_AD_VARIATIONS = {
  control: LOW_AD_CONTROL_CELL,
  variation_1: LOW_AD_VARIATION1,
  variation_2: LOW_AD_VARIATION2,
  variation_3: LOW_AD_VARIATION3,
}

export const STOP_AD_RELOAD_FEATURE_KEY = 'stop-ad-reload'

// Pricing Experiment Easybib and Citation Machine Q4 2023
export const Q423_PRICING_EXP_EB = 'q423-pricing-exp-eb'
export const Q423_PRICING_TEST_FEATURE_EB = 'q423_pricing_test_eb'
export const Q423_PRICING_EXP_CM = 'q423-pricing-exp-cm'
export const Q423_PRICING_TEST_FEATURE_CM = 'q423_pricing_test_cm'

export const PRICING_EXP_VARIATIONS = {
  control: 'BASE',
  low: 'CHEGG_Q423_LOW',
  mid: 'CHEGG_Q423_MID',
  high: 'CHEGG_Q423_HIGH',
}

export interface PricingExpVariables {
  pricingJson: {
    price: string
    pricingExperiment: string
    basePrice: number
  }
}

// export const STOP_AD_RELOAD_CM = 'stop-ad-reload'
// export const STOP_AD_RELOAD_CM_TEST_CELL_VARIABLE = 'reload-copy-22-test'
export const STOP_AD_RELOAD_CM_TEST_CELL_VARIABLE_REGEX = /reload-copy-\d{2}-test/

// export const SEARCH_WIDGET_EXP_CONTROL_VARIABLE = 'search-widget-26-control'
// export const SEARCH_WIDGET_EXP_TEST_VARIABLE = 'search-widget-26-test'

// export const SEARCH_WIDGET_EXP_VARIANTS = {
//   control: SEARCH_WIDGET_EXP_CONTROL_VARIABLE,
//   test: SEARCH_WIDGET_EXP_TEST_VARIABLE,
// }

export const GuestCitationValidityTestCells = {
  control: 'writing-product-53-control',
  above_vid_ad: 'writing-product-53-test',
  below_vid_ad: 'writing-product-54-test',
}
